import moment from 'moment';
import { ReportService } from '@/services';

const M = 'MONTHLY';
const W = 'WEEKLY';
const D = 'DAILY';

const RADIO_VALUE = {
    M,
    W,
    D,
};

export default {
    namespaced: 'true',
    state: getDefaultState(),
    mutations: {
        setReportEmailAutomation(state, value) {
            const { reset } = value;
            let newState = {};

            if (!reset) {
                newState = Object.assign(newState, state.reportEmailAutomation);
            } else {
                newState = Object.assign(newState, {
                    day: 1,
                    date: 1,
                    name: '',
                    emails: [],
                    interval: RADIO_VALUE.D,
                    enabled: false,
                });
            }

            delete value.reset;

            newState = Object.assign(newState, value);
            state.reportEmailAutomation = newState;
        },
        setIsPrintPreviewActive(state, value) {
            state.isPrintPreviewActive = value;
        },
        // TODO can replace on newDashboard ?
        setIsPrinting(state, value) {
            state.isPrinting = value;
        },
        setShouldPrintJustDataPDF(state, value) {
            state.shouldPrintJustDataPDF = value;
        },
        setIsPrintCoverEditing(state, value) {
            state.isPrintCoverEditing = value;
        },
        setIsReportMode(state, value) {
            state.isReportMode = value;
        },
        setIsAddingWidget(state, value) {
            state.isAddingWidget = value;
        },
        setShowSelectModeDropdown(state, value) {
            state.showSelectModeDropdown = value;
        },
        setIsDraggingAnWidgetToMoveBetweenPages(state, value) {
            state.isDraggingAnWidgetToMoveBetweenPages = value;
        },
        setCurrentPageWatching(state, value) {
            state.currentPageWatching = value;
        },
        setShowEmailAutomationSettingPanel(state, value) {
            state.showEmailAutomationSettingPanel = value;
        },
        setShowPDFWillUpdateNoticePopup(state, value) {
            state.showPDFWillUpdateNoticePopup = value;
        },
        setIsShowPDFWillUpdateNoticePopupOpened(state, value) {
            state.isShowPDFWillUpdateNoticePopupOpened = value;
        },
    },
    actions: {
        fetchReportEmailAutomation({ commit }, { viewId }) {
            return ReportService.getEmailAutomationSetting({ viewId }).then(
                (data) => {
                    const emailAutomationSetting = R.propOr({}, 0)(data);
                    commit('setReportEmailAutomation', {
                        reset: true,
                        ...emailAutomationSetting,
                    });
                }
            );
        },
        updateReportEmailAutomation({ commit, state }, payload) {
            const { isLocal = true } = payload;

            if (isLocal) {
                return commit('setReportEmailAutomation', payload);
            } else {
                return ReportService.updateEmailAutomationSetting(payload).then(
                    (data) => {
                        commit('setReportEmailAutomation', {
                            ...data,
                            ...payload,
                        });
                    }
                );
            }
        },
    },
    getters: {
        isEmailAutomationEnabled: R.path(['reportEmailAutomation', 'enabled']),
    },
};

function getDefaultState() {
    return {
        shouldPrintJustDataPDF: false,
        isPrintPreviewActive: false,
        today: moment().format('MMM D, YYYY'),
        isPrintCoverEditing: false,
        // TODO can replace on newDashboard ?
        isPrinting: false,
        isReportMode: false,
        isAddingWidget: false, // to prevent an adding widget event from triggering an event on print cover dom
        showSelectModeDropdown: false,
        isDraggingAnWidgetToMoveBetweenPages: false, // to block event on current page update when moving an widget between pages
        currentPageWatching: 'print-pdf-cover',
        showPDFWillUpdateNoticePopup: false,
        isShowPDFWillUpdateNoticePopupOpened: false,
        showEmailAutomationSettingPanel: false,
        reportEmailAutomation: {
            enabled: false,
        },
    };
}
